import Avatar from './web/Avatar';
import AvatarCircle from './web/AvatarCircle';
Avatar.Circle = AvatarCircle;
export default Avatar;